import { NgComponentOutlet } from '@angular/common';
import { Component, type Type, afterNextRender, signal } from '@angular/core';

/**
 * Route component of the homepage and the map positions.
 * Leaflet reads window/document as soon as it is imported, so the map is only loaded in the browser:
 * on the server (prerender and dev SSR) Angular renders the placeholder.
 * Not @defer: the dev server (HMR) loads deferred dependencies eagerly, which would import Leaflet during SSR.
 */
@Component({
  selector: 'app-map-page',
  template: `
    @if (mapView(); as mapView) {
      <ng-container *ngComponentOutlet="mapView" />
    } @else {
      <div class="map-placeholder"></div>
    }
  `,
  styles: '.map-placeholder { height: calc(100% - 60px); }',
  imports: [NgComponentOutlet],
  host: { style: 'display: contents' },
})
export class MapPageComponent {
  protected readonly mapView = signal<Type<unknown> | undefined>(undefined);

  constructor() {
    afterNextRender(async () => this.mapView.set((await import('./map.component')).MapComponent));
  }
}
